<div class="layout-topbar flex justify-between items-center">
  <div class="layout-topbar-logo-container flex items-center">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      <img
        [src]="layoutService.isDarkTheme() ? logoUrlDark : logoUrl"
        alt="Logo"
        class="logo-image"
        style="height: 2.5rem; width: auto; display: block"
      />
    </a>
  </div>

  <!-- Centered section for selected company -->
  <div class="flex justify-center items-center flex-1">
    <div *ngIf="selectedCompany" class="flex items-center text-lg text-primary font-medium">
      <i class="pi pi-building mr-2"></i>
      <span>{{ selectedCompany.name }}</span>
    </div>
  </div>

  <div class="layout-topbar-actions flex items-center">
    <div class="layout-config-menu">
      <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
        <i
          [ngClass]="{
            'pi ': true,
            'pi-moon': layoutService.isDarkTheme(),
            'pi-sun': !layoutService.isDarkTheme()
          }"
        ></i>
      </button>
      <div class="relative mr-5">
        <button
          class="layout-topbar-action layout-topbar-action-highlight"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          <i class="pi pi-palette"></i>
        </button>
        <app-configurator />
      </div>
    </div>

    <button
      class="layout-topbar-menu-button layout-topbar-action"
      pStyleClass="@next"
      enterFromClass="hidden"
      enterActiveClass="animate-scalein"
      leaveToClass="hidden"
      leaveActiveClass="animate-fadeout"
      [hideOnOutsideClick]="true"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-topbar-menu hidden lg:block relative">
      <div class="layout-topbar-menu-content mr-5">
        <button type="button" class="layout-topbar-action" (click)="toggleMenu($event)" #profileButton>
          <i class="pi pi-user"></i>
          <span>Profile</span>
        </button>
        <p-menu
          #menu
          [popup]="true"
          [model]="menuItems"
          appendTo="body"
          styleClass="layout-profile-menu"
          (onShow)="onMenuShow()"
          (onHide)="onMenuHide()"
        ></p-menu>
      </div>
    </div>
  </div>
</div>
